<template>
  <b-row>
    <b-col
      cols="3"
      align="right"
    >
      <label
        :for="propertyKey"
        class="mt-2"
      >
        {{ label }}:
      </label>
    </b-col>
    <b-col cols="7">
      <button
        v-if="!isEditing"
        type="button"
        class="btn border-0 flex-grow-1 text-left shadow-none"
        @click="editProperty"
      >
        <span v-if="propertyValue">{{ isSensitive ? '********' : propertyValue }}</span>
        <span v-if="!propertyValue && placeholder"><em>{{ placeholder }}</em></span>
      </button>
      <b-form
        v-if="isEditing"
        @submit.prevent="updateProperty"
      >
        <b-form-input
          v-if="isEditing"
          :id="propertyKey"
          ref="propertyInput"
          v-model.trim="value"
          :placeholder="placeholder"
          size="sm"
          type="text"
        />
      </b-form>
    </b-col>
    <b-col cols="2">
      <button
        class="btn btn-outline-primary border-0"
        type="button"
        @click="editProperty"
      >
        <span
          v-if="!isEditing"
          class="fa fa-edit"
        />
        <span
          v-if="isEditing"
          class="fa fa-save"
        />
      </button>
      <button
        class="btn btn-outline-danger border-0"
        type="button"
        @click="deleteProperty"
      >
        <span class="fa fa-trash" />
      </button>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    propertyKey: {
      type: String,
      required: true
    },
    propertyValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    isSensitive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEditing: false,
      value: ''
    }
  },
  computed: {
    currentUserToken() {
      return this.$store.state.auth.userToken
    }
  },
  methods: {
    editProperty() {
      if (this.isEditing) {
        this.updateProperty()
      } else {
        this.isEditing = true
        this.value = this.propertyValue
        this.$nextTick(() => this.$refs.propertyInput.focus())
      }
    },
    updateProperty() {
      this.isEditing = false
      this.$emit('on-edit', this.value)
    },
    deleteProperty() {
      this.$emit('on-delete')
    }
  }
}
</script>
